import { Bff } from 'core/services';

import { actionResourceMapper } from '../actions-mapper';

import type { RequestAction } from '../@types';

/**
 * Return the resources to corresponting BFF endpoints
 *
 */
function getResource(actionType: keyof typeof actionResourceMapper) {
  const key = actionResourceMapper[actionType];

  if (!key) {
    throw new Error(`Action type "${actionType}" is not mapped to any BFF endpoint`);
  }

  return Bff.resources[key];
}

/**
 * Returns the resolved resource appling the type guard and type assertions for the given action
 *
 */
export function resourceResolver<P = Bff.BffResponse>({ payload, type }: RequestAction) {
  const { presenterRequest, presenterResponse, ...options } = getResource(type);

  const presenterResponseFn = Bff.resources[actionResourceMapper[type]].presenterResponse;

  return {
    presenterRequest: presenterRequest ? presenterRequest(payload as unknown as never) : payload,

    presenterResponse: (response: Bff.BffResponse, payload?: any) =>
      presenterResponseFn
        ? presenterResponseFn(response as unknown as P as never, payload as never)
        : payload,
    ...options,
  };
}
